import React from 'react';
type Props = {
  fillColor?: string;
}

const Weekends = (props: Props): JSX.Element => (
<svg id="Layer_1" className='weekend-svg' data-testid="weekend-svg" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16.18 18.55">
  <defs>
    <style>
      {`
       .cls-weekend-icon {
        fill: none;
        stroke: ${props?.fillColor || '#231f20'};
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-width: .5px;
      }
      `}
    </style>
  </defs>
  <path className="cls-weekend-icon" d="M8.45,7.72s-.02,0-.03,0c-.13-1.23-1.16-2.18-2.42-2.18s-2.29.96-2.42,2.18c0,0-.02,0-.03,0-1.35,0-2.45,1.1-2.45,2.45s1.1,2.45,2.45,2.45c0,1.35,1.1,2.45,2.45,2.45s2.45-1.1,2.45-2.45c1.35,0,2.45-1.1,2.45-2.45s-1.1-2.45-2.45-2.45Z"/>
  <line className="cls-weekend-icon" x1="6" y1="9.76" x2="6" y2="18.3"/>
  <polyline className="cls-weekend-icon" points="7.54 11 6 12.51 4.49 11"/>
  <g>
    <circle className="cls-weekend-icon" cx="12.44" cy="3.66" r="1.43"/>
    <line className="cls-weekend-icon" x1="12.44" y1=".25" x2="12.44" y2="1.45"/>
    <line className="cls-weekend-icon" x1="10.67" y1=".7" x2="11.36" y2="1.68"/>
    <line className="cls-weekend-icon" x1="14.21" y1=".7" x2="13.52" y2="1.68"/>
    <g>
      <line className="cls-weekend-icon" x1="8.95" y1="3.8" x2="10.14" y2="3.8"/>
      <line className="cls-weekend-icon" x1="9.4" y1="5.57" x2="10.38" y2="4.89"/>
      <line className="cls-weekend-icon" x1="9.4" y1="2.04" x2="10.38" y2="2.72"/>
    </g>
    <g>
      <line className="cls-weekend-icon" x1="12.44" y1="7" x2="12.44" y2="5.81"/>
      <line className="cls-weekend-icon" x1="14.21" y1="6.55" x2="13.52" y2="5.57"/>
      <line className="cls-weekend-icon" x1="10.67" y1="6.55" x2="11.36" y2="5.57"/>
    </g>
    <g>
      <line className="cls-weekend-icon" x1="15.93" y1="3.66" x2="14.74" y2="3.66"/>
      <line className="cls-weekend-icon" x1="15.48" y1="1.89" x2="14.5" y2="2.57"/>
      <line className="cls-weekend-icon" x1="15.48" y1="5.43" x2="14.5" y2="4.74"/>
    </g>
  </g>
  <line className="cls-weekend-icon" x1=".25" y1="18.3" x2="11.78" y2="18.3"/>
</svg>
);

export default Weekends;
